import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { site } from "@/config/site";
import { Instagram, Facebook, Linkedin, Phone, Mail } from "lucide-react";

export const Footer = () => {
    const year = new Date().getFullYear();
    const socials = [
        { key: "instagram", icon: Instagram, label: "Instagram", url: site.social.instagram },
        { key: "facebook", icon: Facebook, label: "Facebook", url: site.social.facebook },
        { key: "linkedin", icon: Linkedin, label: "LinkedIn", url: site.social.linkedin },
    ].filter((s) => s.url);

    return (
        <footer data-testid="site-footer" className="bg-[#06111F] text-white pt-16 pb-8 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                <div>
                    <Logo size="md" />
                    <p className="text-[#AAB6C5] text-sm mt-4 max-w-xs leading-relaxed">
                        Strony internetowe, aplikacje, branding, social media i marketing dla nowoczesnych firm.
                    </p>
                </div>

                <div>
                    <h4 className="font-display font-semibold text-base mb-4">Usługi</h4>
                    <ul className="space-y-3 text-[#AAB6C5] text-sm">
                        <li><Link to="/strony-internetowe" className="hover:text-[#14B8A6]">Strony internetowe</Link></li>
                        <li><Link to="/aplikacje" className="hover:text-[#14B8A6]">Aplikacje</Link></li>
                        <li><Link to="/branding" className="hover:text-[#14B8A6]">Branding</Link></li>
                        <li><Link to="/social-media" className="hover:text-[#14B8A6]">Social media</Link></li>
                        <li><Link to="/marketing" className="hover:text-[#14B8A6]">Marketing</Link></li>
                        <li><Link to="/automatyzacje-ai" className="hover:text-[#14B8A6]">Automatyzacje AI</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold text-base mb-4">Firma</h4>
                    <ul className="space-y-3 text-[#AAB6C5] text-sm">
                        <li><Link to="/o-nas" className="hover:text-[#14B8A6]">O nas</Link></li>
                        <li><Link to="/realizacje" className="hover:text-[#14B8A6]">Realizacje</Link></li>
                        <li><Link to="/proces" className="hover:text-[#14B8A6]">Proces</Link></li>
                        <li><Link to="/pakiety" className="hover:text-[#14B8A6]">Pakiety</Link></li>
                        <li><Link to="/blog" className="hover:text-[#14B8A6]">Blog</Link></li>
                        <li><Link to="/kontakt" className="hover:text-[#14B8A6]">Kontakt</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold text-base mb-4">Kontakt</h4>
                    <ul className="space-y-3 text-[#AAB6C5] text-sm">
                        <li>
                            <a href={`tel:${site.phoneLink}`} className="hover:text-[#14B8A6] flex items-center gap-2" data-testid="footer-phone">
                                <Phone className="w-4 h-4 text-[#14B8A6]" /> {site.phoneDisplay}
                            </a>
                        </li>
                        <li>
                            <a href={`mailto:${site.email}`} className="hover:text-[#14B8A6] flex items-center gap-2 break-all" data-testid="footer-email">
                                <Mail className="w-4 h-4 text-[#14B8A6]" /> {site.email}
                            </a>
                        </li>
                        {socials.length > 0 && (
                            <li className="flex gap-3 pt-2">
                                {socials.map(({ key, icon: Icon, label, url }) => (
                                    <a
                                        key={key}
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={label}
                                        className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#14B8A6] hover:text-white text-[#AAB6C5] flex items-center justify-center transition-colors"
                                        data-testid={`footer-social-${key}`}
                                    >
                                        <Icon className="w-4 h-4" />
                                    </a>
                                ))}
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-[#AAB6C5]">
                <div>© {year} {site.companyName}</div>
                <div className="flex gap-5">
                    <Link to="/polityka-prywatnosci" className="hover:text-[#14B8A6]">Polityka prywatności</Link>
                    <Link to="/polityka-cookies" className="hover:text-[#14B8A6]">Polityka cookies</Link>
                    <Link to="/regulamin" className="hover:text-[#14B8A6]">Regulamin</Link>
                </div>
            </div>
        </footer>
    );
};
